<template>
  <div class="page container">
    <div class="container">
      <div class="column">
        <div class="content">
          <h3>Cursos</h3>
          <p>Os cursos oferecidos pelo Espaço Winnicott são livres, isto é, não necessitam de autorização, fiscalização ou aprovação do MEC para que possam acontecer (Resolução CNE/CES 7/2011, de 09 de setembro de 2011). Da mesma forma, não é necessária a vinculação do Espaço com nenhuma Instituição de Ensino Superior para que os cursos ocorram. O Espaço Winnicott Brasília oferece atividades diversas a estudantes e profissionais de várias áreas de atuação. Temos Curso de Formação, Cursos de Extensão, Grupos de Estudo e Supervisões de atendimentos clínicos.</p>
          <h3>Cursos oferecidos</h3>
          <ul>
            <li v-for='c in cursos' v-bind:key='c.id'>
            <a href="javascript://" @click='$router.push(`/p/curso/${c.id}`)'>{{c.titulo}}</a>
            </li>
          </ul>
        </div>
        <h3 class="is-size-4"></h3>
        <p class=""></p>
        
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment'

export default {
  name: 'QuemSomos',
  data(){
    return {
      cursos: []
    }
  },
  methods:{
    handleClick() {
        console.log('click');
    },
    getCursos(){
      axios.get(`${global.base}/api/cursos`,{
        }).then((r)=>{
          
          this.cursos = r.data;
          
            
        }).catch(()=>{
        })
    },
    formatFim(f){
      console.log(f)
      return moment(f, "%Y-%MM-%DD").format("DD [de] MMMM [de] YYYY");
    }
  },
  mounted(){
    this.getCursos();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page{
    text-align: left
  }
  .container{
    max-width: 800px;
  }
</style>
